<template>
  <div class="ra-card">
    <div v-if="header" class="ra-card--heading">
      <slot name="header" />
    </div>
    <slot name="content" />
  </div>
</template>

<script>
export default {
  name: "RaCard",
  props: {
    header: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.ra-card {
  background: #fff;
  box-shadow: 0 0 30px 0 rgb(82 63 105 / 7%);
  border-radius: 6px;
  padding: 20px;
  position: relative;
  margin-bottom: 30px;

  .ra-card--heading {
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h6 {
      text-transform: uppercase;
      font-weight: 500;
      font-size: 1rem;
      opacity: 0.5;
      margin-right: 10px;
    }

    p {
      font-weight: 500;
      font-size: 0.8rem;
      margin-right: 10px;
    }
  }
}
</style>
